import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AdvisorData } from '../../../../../../../lib/advisor/advisor.model';
import { IdVerseStatusIconType, IdVerseStatusType } from './id-verse-status-message.model';
import { getIdVerseStatusData, IdVerseStatusData } from './id-verse-status-message.data';

@Component({
  selector: 'ifc-id-verse-status-message',
  templateUrl: './id-verse-status-message.component.html',
  styleUrls: ['./id-verse-status-message.component.scss'],
  standalone: false
})
export class IdVerseStatusMessageComponent implements OnChanges {
  @Input() type: IdVerseStatusType;
  @Input() advisorData: AdvisorData;
  @Input() customerName?: string;
  @Output() action: EventEmitter<IdVerseStatusType> = new EventEmitter<IdVerseStatusType>();

  readonly IconType = IdVerseStatusIconType;

  data: IdVerseStatusData;

  ngOnChanges(): void {
    this.data = getIdVerseStatusData(this.type, this.advisorData, this.customerName);
  }

  onActionClick(): void {
    this.action.emit(this.type);
  }
}
